export default {
    HEADER: 'Company',
    PLACEHOLDER_NAME: 'Enter company name',
    LABEL_NAME: 'Company name',
    LABEL_COMPANY_OWNER: 'Company owner',
    PLACEHOLDER_COUNTRY: 'Enter country',
    LABEL_COUNTRY: 'Country',
    PLACEHOLDER_STREET: 'Enter street',
    LABEL_STREET: 'Street',
    PLACEHOLDER_STREET_NUMBER: 'Enter street number',
    LABEL_STREET_NUMBER: 'Street number',
    PLACEHOLDER_CITY: 'Enter city',
    LABEL_CITY: 'City',
    PLACEHOLDER_ZIP_CODE: 'Enter zip code',
    LABEL_ZIP_CODE: 'Zip code',
    PLACEHOLDER_FLOOR: 'Enter floor',
    LABEL_FLOOR: 'Floor',
    PLACEHOLDER_APARTMENT: 'Enter aparment',
    LABEL_APARTMENT: 'Apartment',
    PLACEHOLDER_VAT_NUMBER: 'Enter VAT number',
    LABEL_VAT_NUMBER: 'VAT number',
    PLACEHOLDER_ID_NUMBER: 'Enter ID number',
    LABEL_ID_NUMBER: 'ID number',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
};
